document.addEventListener('DOMContentLoaded', function() {
  mainTabsSetting();          // メインタブ（一打席速報、出場選手）の設定
  inningTabsSetting();        // イニングタブの設定
  inningScrollSetting();      // イニングのスクロールの設定
  scoreScrollNoticeSetting(); // スクロール判定の設定
  floatingUpdateBarSetting(); // 更新バーの設定
  liveUpdateSetting();        // 更新処理の設定

  function mainTabsSetting() {
    const mainTabs = document.querySelectorAll('.flat-tab-list li');
    const mainContents = document.querySelectorAll('.common-tab-contents');

    if (mainTabs.length > 0 && mainContents.length > 0) {
      mainTabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() {
          mainTabs.forEach(function(item) {
            item.classList.remove('current');
          });
          this.classList.add('current');

          mainContents.forEach(function(content) {
            content.classList.remove('current');
          });
          if (mainContents[index]) {
            mainContents[index].classList.add('current');
          }
        });
      });
    }
  }
  
  function inningTabsSetting() {
    const inningTabs = document.querySelectorAll('.js-inning-tabs li');

    if (inningTabs.length > 0) {
      inningTabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          const targetInning = this.getAttribute('data-inning');

          document.querySelectorAll('.js-inning-tabs li').forEach(function(item) {
            item.classList.remove('current');
          });
          this.classList.add('current');

          document.querySelectorAll('.js-inning-contents .inning-content-area').forEach(function(content) {
            content.classList.remove('current');
          });
          const targetContent = document.querySelector('.js-inning-contents .inning-content-area[data-target-inning="' + targetInning + '"]');
          if (targetContent) {
            targetContent.classList.add('current');
          }
        });
      })
    }
  }

  function inningScrollSetting() {
    const scrollArea = document.querySelector('.js-inning-scroll-area');
    const prevBtn = document.querySelector('.js-inning-scroll-prev');
    const nextBtn = document.querySelector('.js-inning-scroll-next');

    if (scrollArea && prevBtn && nextBtn) {
      const scrollAmout = 50;

      const updateScrollButtons = function() {
        if (scrollArea.scrollWidth > scrollArea.clientWidth) {
          prevBtn.classList.add('is-active');
          nextBtn.classList.add('is-active');
          prevBtn.disabled = scrollArea.scrollLeft <= 0;
          nextBtn.disabled = (scrollArea.scrollLeft + scrollArea.clientWidth) >= (scrollArea.scrollWidth - 1);
        } else {
          prevBtn.classList.remove('is-active');
          nextBtn.classList.remove('is-active');
        }
      };

      prevBtn.addEventListener('click', function() {
        scrollArea.scrollBy({ left: -scrollAmout, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function() {
        scrollArea.scrollBy({ left: scrollAmout, behavior: 'smooth' });
      });

      scrollArea.addEventListener('scroll', updateScrollButtons);
      window.addEventListener('resize', updateScrollButtons);

      setTimeout(updateScrollButtons, 100);
    }
  }

  function scoreScrollNoticeSetting() {
    const tableWrapper = document.querySelector('.score-table-wrapper');
    const scrollNotice = document.querySelector('.js-scroll-notice');

    if (tableWrapper && scrollNotice) {
      const checkScrollable = function() {
        if (tableWrapper.scrollWidth > tableWrapper.clientWidth) {
          scrollNotice.style.display = 'block';
        } else {
          scrollNotice.style.display = 'none';
        }
      };

      const observer = new ResizeObserver(function() {
        checkScrollable();
      });

      observer.observe(tableWrapper);
      checkScrollable();
    }
  }

  function floatingUpdateBarSetting() {
    const updateBar = document.querySelector('.floating-update-bar');
    const targetSection = document.querySelector('.sec.name-btns');

    if (updateBar && targetSection) {
      const checkVisibility = function() {
        const rect = targetSection.getBoundingClientRect();

        let offset;
        if (window.innerWidth <= 768) {
          offset = 150;
        } else {
          offset = 500;
        }

        if (rect.top <= window.innerHeight - offset) {
          updateBar.classList.add('is-hidden');
        } else {
          updateBar.classList.remove('is-hidden');
        }
      };

      window.addEventListener('scroll', checkVisibility, { passive: true });
      window.addEventListener('resize', checkVisibility);
      checkVisibility();
    }
  }

  function liveUpdateSetting() {
    const reloadBtn = document.querySelector('.js-reload-btn');
    const autoUpdateCheck = document.querySelector('.js-auto-update-check');
    const toggleLabel = document.querySelector('.js-toggle-label');

    const targetUrl = 'gameinfo.json';
    let updateTimer = null;
    const reloadTime = 30 * 1000;

    const updateScoreBoard = function (data) {
      const batInnings = data?.['bat-first-team-info']?.['inning-info']?.inning;
      const fieldInnings = data?.['field-first-team-info']?.['inning-info']?.inning;

      const batInningArray = Array.isArray(batInnings) ? batInnings : (batInnings ? [batInnings] : []);
      const fieldInningArray = Array.isArray(fieldInnings) ? fieldInnings : (fieldInnings ? [fieldInnings] : []);

      const statusFlg = data?.current?.['@attributes']?.['flg-status'];

      const topTotal = data?.['game-info']?.['@attributes']?.['top-total-score'] || '0';
      const bottomTotal = data?.['game-info']?.['@attributes']?.['bottom-total-score'] || '0';
      if (['0', '5', '6'].includes(statusFlg)) {
        topTotal = '';
        bottomTotal = '';
      }

      const scoreTopElem = document.querySelector('.score.top');
      const scoreBottomElem = document.querySelector('.score.bottom');
      if (scoreTopElem) scoreTopElem.textContent = topTotal;
      if (scoreBottomElem) scoreBottomElem.textContent = bottomTotal;

      const theadRow = document.querySelector('.score-table thead tr');
      const topRow = document.querySelector('.score-table .js-top-inning');
      const bottomRow = document.querySelector('.score-table .js-bottom-inning');

      if (!theadRow || !topRow || !bottomRow) return;

      const maxInning = Math.max(9, batInningArray.length);
      let ths = theadRow.querySelectorAll('th:not(.team-col):not(.sp-label-col):not(.total)');
      let currentCols = ths.length;

      while (currentCols < maxInning) {
        currentCols++;
        const totalTh = theadRow.querySelector('.total');
        if (totalTh) {
          const newTh = document.createElement('th');
          newTh.textContent = currentCols;
          theadRow.insertBefore(newTh, totalTh);
          
          const newTopTd = document.createElement('td');
          topRow.insertBefore(newTopTd, topRow.querySelector('.total'));
          
          const newBottomTd = document.createElement('td');
          bottomRow.insertBefore(newBottomTd, bottomRow.querySelector('.total'));
        }
      }

      const topTds = topRow.querySelectorAll('td:not(.total)');
      const bottomTds = bottomRow.querySelectorAll('td:not(.total)');

      batInningArray.forEach((inning, index) => {
        if (topTds[index]) topTds[index].textContent = inning['@attributes']['point'] || '';
      });
      for (let i = batInningArray.length; i < topTds.length; i++) {
        if (topTds[i]) topTds[i].textContent = '';
      }

      fieldInningArray.forEach((inning, index) => {
        if (bottomTds[index]) bottomTds[index].textContent = inning['@attributes']['point'] || '';
      });
      for (let i = fieldInningArray.length; i < bottomTds.length; i++) {
        if (bottomTds[i]) bottomTds[i].textContent = '';
      }

      const topTotalTd = topRow.querySelector('.js-top-inning .total');
      const bottomTotalTd = bottomRow.querySelector('.js-bottom-inning .total');
      if (topTotalTd) topTotalTd.textContent = topTotal;
      if (bottomTotalTd) bottomTotalTd.textContent = bottomTotal;
    };

    const updateGameResult = function (data) {
      const statusFlg = data?.current?.['@attributes']?.['flg-status'];
      const inputMode = data?.['game-info']?.['@attributes']?.['input-mode'];
      const time = data?.['game-info']?.['@attributes']?.['time'] || '';
      const inning = data?.current?.['@attributes']?.['inning'] || '';
      const topBottom = data?.current?.['@attributes']?.['top-bottom'] || '';
      const endComment = data?.['game-info']?.['@attributes']?.['end-comment'];

      let dispStatus = '';
      let statusClass = '';
      let gameDispStatus = '';

      switch (statusFlg) {
        case '0':
          dispStatus = '予定';
          statusClass = 'is-pre';
          gameDispStatus = `${time}開始`;
          break;
        case '1':
          dispStatus = (inputMode === '3') ? '一打席速報中' : '速報中';
          statusClass = (inputMode === '3') ? 'is-livedetail' : 'is-live';
          gameDispStatus = `${inning}回${topBottom}`;
          break;
        case '2':
          dispStatus = '中断中';
          statusClass = (inputMode === '3') ? 'is-livedetail' : 'is-live';
          gameDispStatus = `${inning}回${topBottom}`;
          break;
        case '3':
        case '4':
        case '9':
        case '10':
          dispStatus = (inputMode === '3') ? '結果（一打席情報あり）' : '結果';
          statusClass = 'is-result';
          
          const batInningArray = Array.isArray(data?.['bat-first-team-info']?.['inning-info']?.inning)
            ? data['bat-first-team-info']['inning-info']['inning']
            : (data?.['bat-first-team-info']?.['inning-info']?.inning ? [data['bat-first-team-info']['inning-info']['inning']] : []);
          const endInning = batInningArray.length || inning;
          
          if (statusFlg === '4') gameDispStatus = `${endInning}回コールド`;
          else if (statusFlg === '9') gameDispStatus = `${endInning}回引き分け再試合`;
          else if (statusFlg === '10') gameDispStatus = `${endInning}回引き分け`;
          else gameDispStatus = '試合終了';
          break;
        case '6':
          dispStatus = 'ノーゲーム';
          statusClass = 'is-suspension';
          gameDispStatus = '';
          break;
        case '8':
          dispStatus = '継続試合';
          statusClass = (inputMode === '3') ? 'is-livedetail' : 'is-live';
          gameDispStatus = `${inning}回継続試合`;
          break;
        case '5':
        case '7':
        default:
          if (statusFlg === '5') dispStatus = '中止';
          else if (statusFlg === '7') dispStatus = '没収試合';
          statusClass = 'is-suspension';
          gameDispStatus = `${time}開始`;
          break;
      }

      const gameOutline = document.querySelector('.game-outline');
      const statusLabel = document.querySelector('.game-outline .status');

      if (gameOutline && statusLabel) {
        gameOutline.classList.remove('is-pre', 'is-live', 'is-livedetail', 'is-result', 'is-suspension');
        if (statusClass !== '') gameOutline.classList.add(statusClass);
        statusLabel.textContent = dispStatus;
      }

      document.querySelectorAll('.js-game-status').forEach(elem => {
        elem.textContent = gameDispStatus;
      });

      const senpyoWrapper = document.querySelector('.js-senpyo-wrapper');
      if (['3', '4', '9', '10'].includes(statusFlg) || endComment) {
        if (senpyoWrapper) {
          if (endComment && endComment.trim() !== '') {
            senpyoWrapper.style.display = '';
          } else {
            senpyoWrapper.style.display = 'none';
          }

          const p1Elem = document.querySelector('.js-senpyo-p1');
          const c1Elem = document.querySelector('.js-senpyo-c1');
          const p2Elem = document.querySelector('.js-senpyo-p2');
          const c2Elem = document.querySelector('.js-senpyo-c2');
          const textElem = document.querySelector('.js-senpyo-text');

          if (p1Elem) p1Elem.textContent = data?.['bat-first-team-info']?.battery?.['@attributes']?.pitcher || '';
          if (c1Elem) c1Elem.textContent = data?.['bat-first-team-info']?.battery?.['@attributes']?.catcher || '';
          if (p2Elem) p2Elem.textContent = data?.['field-first-team-info']?.battery?.['@attributes']?.pitcher || '';
          if (c2Elem) c2Elem.textContent = data?.['field-first-team-info']?.battery?.['@attributes']?.catcher || '';
          if (textElem && endComment) textElem.innerHTML = endComment.replace(/\n/g, '<br>');
        }
      } else {
        if (senpyoWrapper) senpyoWrapper.style.display = 'none';
      }
    };

    const updateLiveElements = function(data) {
      const current = data?.current?.['@attributes'];
      const batTeam = data?.['bat-first-team-info'];
      const fieldTeam = data?.['field-first-team-info'];

      if (!current || !batTeam || !fieldTeam) return;

      const statusFlg = current['flg-status'];
      const liveContainer = document.querySelector('.latest-data-container');
      const liveBadges = document.querySelectorAll('.live-badge');
      const inningTabWrapper = document.querySelector('.inning-tab-wrapper');
      if (statusFlg === '1' || statusFlg === '2') {
        if (liveContainer) liveContainer.style.display = '';
        liveBadges.forEach(badge => badge.style.display = '');
        if (inningTabWrapper) inningTabWrapper.classList.remove('is-standalone'); 
      } else {
        if (liveContainer) liveContainer.style.display = 'none';
        liveBadges.forEach(badge => badge.style.display = 'none');
        if (inningTabWrapper) inningTabWrapper.classList.add('is-standalone'); 
        return;
      }

      const outCountElem = document.querySelector('.js-out-count');
      if (outCountElem) {
        const outCount = current['out-count'] === '3' ? '0' : current['out-count'];
        outCountElem.setAttribute('data-count', outCount);
      }

      const runnerElem = document.querySelector('.js-runner');
      if (runnerElem) {
        const runners = current['runner'].split('');
        const lis = runnerElem.querySelectorAll('li:not(.home-plate)');
        if (lis.length >= 3) {
          lis[0].classList.toggle('is-active', runners[2] === '1');
          lis[1].classList.toggle('is-active', runners[1] === '1');
          lis[2].classList.toggle('is-active', runners[0] === '1');
        }
      }

      const inningElem = document.querySelector('.js-inning');
      const topBottomElem = document.querySelector('.js-top-bottom');
      const batterElem = document.querySelector('.js-current-batter');
      if (inningElem) inningElem.textContent = current['inning'];
      if (topBottomElem) topBottomElem.textContent = current['top-bottom'];
      if (batterElem) {
        batterElem.textContent = current['out-count'] === '3' ? '' : `${current['batter-last']} ${current['batter-first']}`;
      }

      const isTop = current['top-bottom'] === '表';
      const offenseTeam = isTop ? batTeam : fieldTeam;
      const defenseTeam = isTop ? fieldTeam : batTeam;

      const teamElem = document.querySelector('.js-current-team');
      if (teamElem) teamElem.textContent = offenseTeam['team']['@attributes']['name'];

      const pitcherElem = document.querySelector('.js-pitcher');
      const catcherElem = document.querySelector('.js-catcher');
      
      if (defenseTeam && defenseTeam.battery) {
        const pitchers = defenseTeam.battery['@attributes'].pitcher.replace(/-/g, ",").split(',');
        const catchers = defenseTeam.battery['@attributes'].catcher.replace(/-/g, ",").split(',');
        
        if (pitcherElem) pitcherElem.textContent = pitchers[pitchers.length - 1];
        if (catcherElem) catcherElem.textContent = catchers[catchers.length - 1];
      }
    };

    const fetchAndUpdateGameInfo = function() {
      if (reloadBtn) reloadBtn.classList.add('is-animating');

      fetch(targetUrl, { cache: "no-store" })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(data => {
          updateScoreBoard(data);
          updateGameResult(data);
          updateLiveElements(data);
        })
        .catch(error => {
          console.error('データの取得失敗:', error);
        })
        .finally(() => {
          setTimeout(() => {
            if (reloadBtn) reloadBtn.classList.remove('is-animating');
        }, 500);
      });
    };

    if (reloadBtn) {
      reloadBtn.addEventListener('click', function() {
        fetchAndUpdateGameInfo();
      });
    }

    if (autoUpdateCheck) {
      autoUpdateCheck.addEventListener('change', function() {
        if (this.checked) {
          if (toggleLabel) toggleLabel.textContent = '自動更新 ON';
          if (reloadBtn) reloadBtn.disabled = true;
          updateTimer = setInterval(fetchAndUpdateGameInfo, reloadTime);
        } else {
          if (toggleLabel) toggleLabel.textContent = '自動更新 OFF';
          if (reloadBtn) reloadBtn.disabled = false;
          clearInterval(updateTimer);
          updateTimer = null;
        }
      });

      if (autoUpdateCheck.checked) {
        if (reloadBtn) reloadBtn.disabled = true;
        updateTimer = setInterval(fetchAndUpdateGameInfo, reloadTime);
      }
    }
  }
});
